import { graphql } from 'react-relay';

export const createPresetConfigurationMacroCategoryMutation = graphql`
    mutation presetConfigurationsQueriesCreateMacroCategoryMutation($name: String!, $displayOrder: Int) {
        insertMacroCompositionCategory(name: $name, displayOrder: $displayOrder) {
            id
            macroCategoryID
            name
            sellerID
            displayOrder
        }
    }
`;

export const updatePresetConfigurationMacroCategoryMutation = graphql`
    mutation presetConfigurationsQueriesUpdateMacroCategoryMutation($input: CompositionMacroCategoryUpdateInput!) {
        updateMacroCompositionCategory(compositionMacroCategory: $input) {
            id
            macroCategoryID
            name
            sellerID
            displayOrder
        }
    }
`;

export const deletePresetConfigurationMacroCategoryMutation = graphql`
    mutation presetConfigurationsQueriesDeleteMacroCategoryMutation($id: Long!) {
        deleteMacroCompositionCategory(id: $id) {
            id
            macroCategoryID
            name
            sellerID
            displayOrder
        }
    }
`;

export const createPresetConfigurationCategoryMutation = graphql`
    mutation presetConfigurationsQueriesCreateCategoryMutation($input: CompositionCategoryUpdateInput!) {
        insertCompositionCategory(compositionCategory: $input) {
            id
            categoryID
            name
            displayOrder
        }
    }
`;

export const updatePresetConfigurationCategoryMutation = graphql`
    mutation presetConfigurationsQueriesUpdateCategoryMutation($input: CompositionCategoryUpdateInput!) {
        updateCompositionCategory(compositionCategory: $input) {
            id
            categoryID
            name
            displayOrder
        }
    }
`;

export const deletePresetConfigurationCategoryMutation = graphql`
    mutation presetConfigurationsQueriesDeleteCategoryMutation($macroId: Long!, $id: Long!) {
        deleteCompositionCategory(macroId: $macroId, id: $id) {
            id
            categoryID
            name
            displayOrder
        }
    }
`;

export const iFrameUrlQuery = graphql`
    query presetConfigurationsQueriesiFrameUrlQuery($input: ConfiguratorTemplateInput!) {
        preSetPreviewUrl(input: $input)
    }
`;

export const deletePresetConfigurationCompositionMutation = graphql`
    mutation presetConfigurationsQueriesDeleteCompositionMutation($deleteCompositionId: ID!) {
        deleteComposition(id: $deleteCompositionId) {
            id
        }
    }
`;
